import React from "react";
import FilterIcon from "../../../components/icons/FilterIcon";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { commonAction } from "../../../redux/features/commonSlice";
import "./ListFilterButton.scss";
import { CommonEnums } from "../../../enums/common.enums";

const ListFilterButton = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const onClickFilter = () => {
    dispatch(commonAction?.setHomePageFilter());
  };

  const checkFilter = () => {
    let filter_check = false;
    // user filter
    let role = searchParams.get(CommonEnums.queryParams?.role) || "";

    // agency filter
    let agent_id = searchParams.get(CommonEnums.queryParams?.agent_id) || "";
    let agent_name =
      searchParams.get(CommonEnums?.queryParams?.agent_name) || "";
    let registration_status =
      searchParams.get(CommonEnums.queryParams?.registration_status) || "";
    let cities_id =
      searchParams.get(CommonEnums.queryParams?.agentFilter?.cities) || "";

    // agent filter
    let agency_id = searchParams.get(CommonEnums.queryParams?.agency_id) || "";

    // template types filter
    let subscription_type =
      searchParams.get(CommonEnums.queryParams?.subscription_type) || "";
    let post_type = searchParams.get(CommonEnums.queryParams?.post_type) || "";
    let stage_type =
      searchParams.get(CommonEnums.queryParams?.stage_type) || "";

    let listing_type =
      searchParams.get(CommonEnums.queryParams?.listing_type) || "";

    // template filter
    let subscription_plan =
      searchParams.get(CommonEnums.queryParams?.role) || "";
    let template_type = searchParams.get(CommonEnums.queryParams?.role) || "";

    // common
    let start_date = searchParams.get(CommonEnums.queryParams.start_date) || "";
    let end_date = searchParams.get(CommonEnums.queryParams.end_date) || "";
    let status = searchParams.get(CommonEnums?.queryParams?.status) || "";

    // properties

    let agency_name = searchParams.get(CommonEnums.queryParams?.agency_name);
    let listing_type_ids = searchParams.get(
      CommonEnums.queryParams?.listing_type_ids
    );
    let property_stage_ids = searchParams.get(
      CommonEnums.queryParams?.property_stage_ids
    );
    let selected_city_ids = searchParams.get(
      CommonEnums.queryParams?.selected_city_ids
    );
    let selected_state_ids = searchParams.get(
      CommonEnums.queryParams?.selected_state_ids
    );
    let property_type_ids = searchParams.get(
      CommonEnums.queryParams?.property_type_ids
    );
    let selected_country_ids = searchParams.get(
      CommonEnums.queryParams?.selected_country_ids
    );

    let user_role = searchParams.get(CommonEnums.queryParams?.user_role);

    let check_value =
      role ||
      agent_id ||
      agent_name ||
      registration_status ||
      cities_id ||
      agency_id ||
      subscription_type ||
      post_type ||
      stage_type ||
      subscription_plan ||
      listing_type ||
      template_type ||
      start_date ||
      end_date ||
      status ||
      agency_name ||
      listing_type_ids ||
      property_stage_ids ||
      selected_city_ids ||
      selected_state_ids ||
      property_type_ids ||
      selected_country_ids ||
      user_role;

    if (check_value) {
      filter_check = true;
    } else {
      filter_check = false;
    }

    return filter_check;
  };

  return (
    <button
      className={`list-filter-button ${
        checkFilter() ? "list-filter-button-active" : ""
      } `}
      onClick={onClickFilter}
    >
      <div className="filter-icon">
        <FilterIcon />
      </div>
      <p> Filters</p>
    </button>
  );
};

export default ListFilterButton;
